// FACTURACION-ACCIONES-CONTIFICO-09 -- fuente canónica de qué acciones de
// integración con Contífico corresponden a una factura del listado, según su
// estado local y su estado real respecto de Contífico.
//
// Estado Contífico (campos que devuelve GET /billing):
//   - id_contifico     : "" (o null) hasta que un envío exitoso persiste el id
//                        REAL del documento en Contífico. Es EL predicado de
//                        "registrada/autorizada" (mismo criterio que el filtro
//                        contifico=AUTORIZADO del backend y que DeleteInvoice).
//   - estado_contifico : 'PENDING'|'PROCESSING'|'CREATED'|'FAILED'|null --
//                        máquina de estados del primer consumo. 'FAILED' es el
//                        único marcador confiable de "el envío se intentó y
//                        falló" (el flujo moderno NO guarda el texto del error
//                        en mensaje_contifico).
//   - mensaje_contifico: null al crear; "Ok" tras éxito; texto de error sólo
//                        por la vía legacy (PUT /billing/:documento). Se sigue
//                        respetando por compatibilidad histórica.

export const estaRegistradaEnContifico = (factura) =>
  !!(factura?.id_contifico && String(factura.id_contifico).trim() !== "");

// 🐞 "Ver errores": sólo cuando hay un error REAL persistido para esa factura.
// NO se infiere de "id_contifico vacío" (una factura local nueva simplemente
// no se ha enviado todavía). Nunca llama a Contífico.
export const tieneErroresContifico = (factura) => {
  if (!factura) return false;
  if (factura.estado_contifico === "FAILED") return true;
  const msg = String(factura.mensaje_contifico || "").trim();
  return msg !== "" && msg.toLowerCase() !== "ok";
};

// 📄 RIDE: sólo una FAC activa YA registrada/autorizada en Contífico (id real).
// Así el usuario nunca puede disparar getDocumentoContifico(...) sobre una
// factura que nunca fue registrada.
export const puedeVerRide = (factura) =>
  factura?.estado === "A" &&
  factura?.documento === "FAC" &&
  estaRegistradaEnContifico(factura);

// ↻ Enviar / Reenviar: FAC activa que todavía NO tiene documento externo
// válido. El permiso billing.contifico_send se valida aparte, en el JSX.
export const puedeEnviarContifico = (factura) =>
  factura?.estado === "A" &&
  factura?.documento === "FAC" &&
  !estaRegistradaEnContifico(factura);

// 🗑 Anular: se preservan las reglas existentes -- factura activa (el permiso
// billing.cancel y las reglas financieras del backend se validan aparte).
export const puedeAnular = (factura) => factura?.estado === "A";
